module.exports = __webpack_public_path__ + "547cb84c6173063ef8e6a07a625a349e.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/Graphik-Medium.ttf
// module id = 427
// module chunks = 0